@if (chip(); as chip) {
  <div class="flex min-w-[16rem] max-w-xs flex-col gap-3 p-3">
    <div class="flex items-center gap-1.5 text-sm font-semibold">
      @if (chip.icon; as icon) {
        <mat-icon class="icon-sm shrink-0">{{ icon }}</mat-icon>
      }
      @if (chip.amount; as amount) {
        <span>{{ amount }}</span>
      }
      <span>{{ chip.label }}</span>
    </div>

    @for (section of chip.tooltipSections; track section.body) {
      <div class="flex flex-col gap-0.5">
        @if (section.heading; as heading) {
          <div
            class="flex items-center gap-1.5 text-xs font-semibold"
            [class.text-red-600]="section.tone === depositChipTone.Attention"
          >
            @if (section.icon; as icon) {
              <mat-icon class="icon-xs shrink-0">{{ icon }}</mat-icon>
            }
            <span>{{ heading }}</span>
          </div>
        }
        <span class="text-xs opacity-80">{{ section.body }}</span>
      </div>
    }
  </div>
}
